import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import success from '@/views/success'
import verify from '@/views/verify'
import warnInfo from '@/views/warnInfo'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/:phone',
      name: 'home',
      component: home
    },
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/s/success',
      name: 'success',
      component: success
    },
    {
      path: '/v/:id',
      name: 'verify',
      component: verify
    },
    {
      path: '/warn/info/:id',
      name: 'warnInfo',
      component: warnInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js